import { extends as _extends } from './_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';

var InfoOutline = function InfoOutline(props) {
  var _props$color = props.color,
      color = _props$color === void 0 ? 'currentColor' : _props$color,
      size = props.size,
      style = props.style;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: style
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M13.0086 12.0567V16.0567C13.0086 16.6092 12.5586 17.0567 12.0087 17.0567C11.4587 17.0567 11.0087 16.6092 11.0087 16.0567V12.0567C11.0087 11.5042 11.4587 11.0568 12.0087 11.0568C12.5586 11.0568 13.0086 11.5042 13.0086 12.0567Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0087 9.72279C12.7704 9.72279 13.3879 9.10532 13.3879 8.34363C13.3879 7.58194 12.7704 6.96447 12.0087 6.96447C11.247 6.96447 10.6295 7.58194 10.6295 8.34363C10.6295 9.10532 11.247 9.72279 12.0087 9.72279Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9999 12C21.9999 6.4765 17.525 2.0005 12 2C6.47499 2.0005 2 6.4765 2 12C2 17.5235 6.47499 21.9995 12 22C17.525 21.9995 21.9999 17.5235 21.9999 12ZM19.9999 12C19.9999 14.2125 19.105 16.206 17.655 17.657C16.205 19.106 14.21 19.9995 12 20C9.78998 19.9995 7.79495 19.106 6.34496 17.657C4.89496 16.206 3.99999 14.2125 3.99999 12C3.99999 9.7875 4.89496 7.79399 6.34496 6.34299C7.79495 4.89399 9.78998 4.0005 12 4C14.21 4.0005 16.205 4.89399 17.655 6.34299C19.105 7.79399 19.9999 9.7875 19.9999 12Z",
    fill: color
  }));
};

export { InfoOutline };
